import retrato_1 from "./../../assets/images/proyectos/retratos/retratos_1.jpg";
import retrato_2 from "./../../assets/images/proyectos/retratos/retratos_2.jpg";
import retrato_3 from "./../../assets/images/proyectos/retratos/retratos_3.jpg";
import retrato_4 from "./../../assets/images/proyectos/retratos/retratos_4.jpg";
import retrato_5 from "./../../assets/images/proyectos/retratos/retratos_5.jpg";
import retrato_6 from "./../../assets/images/proyectos/retratos/retratos_6.jpg";
import retrato_7 from "./../../assets/images/proyectos/retratos/retratos_7.jpg";
import retrato_8 from "./../../assets/images/proyectos/retratos/retratos_8.jpg";
import retrato_9 from "./../../assets/images/proyectos/retratos/retratos_9.jpg";
import retrato_10 from "./../../assets/images/proyectos/retratos/retratos_10.jpg";
import retrato_11 from "./../../assets/images/proyectos/retratos/retratos_11.jpg";
import retrato_12 from "./../../assets/images/proyectos/retratos/retratos_12.jpg";
import retrato_13 from "./../../assets/images/proyectos/retratos/retratos_13.jpg";
import retrato_14 from "./../../assets/images/proyectos/retratos/retratos_14.jpg";
import retrato_15 from "./../../assets/images/proyectos/retratos/retratos_15.jpg";
import retrato_16 from "./../../assets/images/proyectos/retratos/retratos_16.jpg";
import retrato_17 from "./../../assets/images/proyectos/retratos/retratos_17.jpg";
import retrato_18 from "./../../assets/images/proyectos/retratos/retratos_18.jpg";
import retrato_19 from "./../../assets/images/proyectos/retratos/retratos_19.jpg";
import retrato_20 from "./../../assets/images/proyectos/retratos/retratos_20.jpg";
import retrato_21 from "./../../assets/images/proyectos/retratos/retratos_21.jpg";
import retrato_22 from "./../../assets/images/proyectos/retratos/retratos_22.jpg";
import retrato_23 from "./../../assets/images/proyectos/retratos/retratos_23.jpg";
import retrato_24 from "./../../assets/images/proyectos/retratos/retratos_24.jpg";
import retrato_25 from "./../../assets/images/proyectos/retratos/retratos_25.jpg";
import retrato_26 from "./../../assets/images/proyectos/retratos/retratos_26.jpg";
import retrato_27 from "./../../assets/images/proyectos/retratos/retratos_27.jpg";
import retrato_28 from "./../../assets/images/proyectos/retratos/retratos_28.jpg";
import retrato_29 from "./../../assets/images/proyectos/retratos/retratos_29.jpg";
import retrato_30 from "./../../assets/images/proyectos/retratos/retratos_30.jpg";
import retrato_31 from "./../../assets/images/proyectos/retratos/retratos_31.jpg";
import retrato_32 from "./../../assets/images/proyectos/retratos/retratos_32.jpg";
import retrato_33 from "./../../assets/images/proyectos/retratos/retratos_33.jpg";
import retrato_34 from "./../../assets/images/proyectos/retratos/retratos_34.jpg";
import retrato_35 from "./../../assets/images/proyectos/retratos/retratos_35.jpg";
import retrato_36 from "./../../assets/images/proyectos/retratos/retratos_36.jpg";
import retrato_37 from "./../../assets/images/proyectos/retratos/retratos_37.jpg";
import retrato_38 from "./../../assets/images/proyectos/retratos/retratos_38.jpg";
import retrato_39 from "./../../assets/images/proyectos/retratos/retratos_39.jpg";
import retrato_40 from "./../../assets/images/proyectos/retratos/retratos_40.jpg";
import retrato_41 from "./../../assets/images/proyectos/retratos/retratos_41.jpg";
import retrato_42 from "./../../assets/images/proyectos/retratos/retratos_42.jpg";
import retrato_43 from "./../../assets/images/proyectos/retratos/retratos_43.jpg";
import retrato_44 from "./../../assets/images/proyectos/retratos/retratos_44.jpg";
import retrato_45 from "./../../assets/images/proyectos/retratos/retratos_45.jpg";
import retrato_46 from "./../../assets/images/proyectos/retratos/retratos_46.jpg";
import retrato_47 from "./../../assets/images/proyectos/retratos/retratos_47.jpg";
import retrato_48 from "./../../assets/images/proyectos/retratos/retratos_48.jpg";
import retrato_49 from "./../../assets/images/proyectos/retratos/retratos_49.jpg";
import retrato_50 from "./../../assets/images/proyectos/retratos/retratos_50.jpg";
import retrato_51 from "./../../assets/images/proyectos/retratos/retratos_51.jpg";
import retrato_52 from "./../../assets/images/proyectos/retratos/retratos_52.jpg";
import retrato_53 from "./../../assets/images/proyectos/retratos/retratos_53.jpg";
import retrato_54 from "./../../assets/images/proyectos/retratos/retratos_54.jpg";
import retrato_55 from "./../../assets/images/proyectos/retratos/retratos_55.jpg";
import retrato_56 from "./../../assets/images/proyectos/retratos/retratos_56.jpg";
import retrato_57 from "./../../assets/images/proyectos/retratos/retratos_57.jpg";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
        name: 'Mirador del Alto',
        image: retrato_5,
        description: [
            'Esta campaña la hicimos para la nueva ampliación del Mall Alto Las Condes que se construía en Santiago y no teníamos referencia de la decoración, por lo que había que representar sensaciones de estilo de vida. Creamos muchas situaciones distintas con una variedad de personajes y, como siempre, nos reímos mucho.'
        ],
        children: [
            {
                name: retrato_5
            },
            {
                name: retrato_6
            },
            {
                name: retrato_7
            },
            {
                name: retrato_8
            },
        ]
    }, {
        name: 'Hoteles Awasi',
        image: retrato_9,
        description: [
            'Fui comisionado para fotografías dos Hoteles Awasi, en Patagonia y en San Pedro de Atacama. Solo arquitectura. Pero, me pareció súper atractivo el tema del personal de los hoteles, los guías, administración, chefs y personal en general, así que entre foto y foto, les iba haciendo retratos a quienes me ayudaban. Esta idea pasó a ser casi mas importante en la promoción del hotel ya que el personal era quienes le daban un encanto especial a los hoteles.'
        ],
        children: [
            {
                name: retrato_9
            },
            {
                name: retrato_10
            },
            {
                name: retrato_11
            },
            {
                name: retrato_12
            },
            {
                name: retrato_13
            },
            {
                name: retrato_14
            },
            {
                name: retrato_15
            },
            {
                name: retrato_16
            },
            {
                name: retrato_17
            },
        ]
    }, {
        name: 'Compaq',
        image: retrato_2,
        description: [
            'Por esta foto, tengo un sobrino que hasta el día de hoy me odia. Falló el modelo y fui a buscar a mi sobrino Javier, quien detestó la foto. Desgraciadamente no recuerdo el nombre de la niña que era no solo preciosa sino que muy especial en todo sentido y me ayudó mucho con el acting.',
        ],
        children: [
            {
                name: retrato_2
            },
        ]
    }, {
        name: 'Banco Estado',
        image: retrato_18,
        description: [
            'Para el Banco del Estado me piden hacer fotos para todo tipo de segmentos, y nos ha tocado conocer personajes de Chile.  Siempre me ha gustado llegar a un lugar que no conozco e inventar en pocos minutos “algo” que pueda servir para una imagen muy natural, pero bonita. Muy entretenido además estar en un bote en el mar, con flashes a los lados para iluminar al pescador.'
        ],
        children: [
            {
                name: retrato_18
            },
            {
                name: retrato_19
            },
            {
                name: retrato_20
            },
            {
                name: retrato_21
            },
            {
                name: retrato_22
            },
            {
                name: retrato_23
            },
        ]
    }, {
        name: 'Conapram',
        image: retrato_24,
        description: [
            'Esta campaña benéfica, algunos rostros de la televisión aceptaron que los envejeciéramos para apoyar una corporación de ayuda a la vejez.',
            'En contra de lo que siempre hay que hacer, esto es: tratar de que los personajes salgan muy bien, teníamos que resaltar rasgos para que vía retoque hubiera material para el envejecimiento, pero guardando la belleza de cada persona. O sea, resaltar “defectos” manteniendo la belleza. Un difícil compromiso.'
        ],
        children: [
            {
                name: retrato_24
            },
            {
                name: retrato_25
            },
            {
                name: retrato_26
            },
            {
                name: retrato_27
            },
        ]
    }, {
        name: 'Cine boys',
        image: retrato_28,
        description: [
            'Esta campaña benéfica, algunos rostros de la televisión aceptaron que los envejeciéramos para apoyar una corporación de ayuda a la vejez.',
            'En contra de lo que siempre hay que hacer, esto es: tratar de que los personajes salgan muy bien, teníamos que resaltar rasgos para que vía retoque hubiera material para el envejecimiento, pero guardando la belleza de cada persona. O sea, resaltar “defectos” manteniendo la belleza. Un difícil compromiso.'
        ],
        children: [
            {
                name: retrato_28
            },
            {
                name: retrato_29
            },
            {
                name: retrato_30
            },
        ]
    }, {
        name: 'Proyecto 7',
        image: retrato_24,
        description: [
            'He ido de a poco fotografiando personas que trabajan en el mundo del Cine en Chile, detrás de las cámaras. Son retratos sinceros, sin otra pretensión que mostrar estas personas que hacen tanto por esta industria y que han logrado ayudar a que el Cine en estas latitudes tenga la calidad que tiene hoy.'
        ],
        children: [
            {
                name: retrato_24
            },
            {
                name: retrato_25
            },
            {
                name: retrato_26
            },
            {
                name: retrato_27
            },
        ]
    }, {
        name: 'Caddies',
        image: retrato_31,
        description: [
            'Mi pasión fuera de lo audiovisual es el Golf. En mi Club, al que voy desde niño, están nuestros muy queridos Caddies, muchos de los cuales me criaron y educaron en este deporte, y el honor que hay detrás. Muchos ya partieron y salvo unas pocas fotos, no quedaron registros de ellos, a pesar que fueron grandes compañeros. Así que realicé un registro completo de cada uno de ellos, en el lugar de la Cancha que mas les gustaba, dado el enorme cariño que le tienen.'
        ],
        children: [
            {
                name: retrato_31
            },
            {
                name: retrato_32
            },
            {
                name: retrato_33
            },
            {
                name: retrato_34
            },
        ]
    }, {
        name: 'Maggi',
        image: retrato_36,
        description: [
            'Me tocó realizar un libro para Nestlé en la fábrica de MAGGI en San Fernando. Recorrimos toda la planta retratando a sus trabajadores en su ambiente de trabajo. Regalamos cámaras desechables para que ellos fotografiaran sus intereses personales e hicimos un exitoso concurso de fotografía. Muy linda experiencia. Cada área de la fábrica representada en sus lugares de trabajo.'
        ],
        children: [
            {
                name: retrato_36
            },
            {
                name: retrato_37
            },
            {
                name: retrato_38
            },
            {
                name: retrato_39
            },
            {
                name: retrato_40
            },
        ]
    }, {
        name: 'Quiltros',
        image: retrato_42,
        description: [
            'Para unos amigos de una Agencia de Publicidad, me pidieron hacerles unos retratos en la calle fuera de la oficina. Agradezco tanto que ahora haya flashes con baterías…'
        ],
        children: [
            {
                name: retrato_42
            },
            {
                name: retrato_43
            },
        ]
    }, {
        name: 'Claudia',
        image: retrato_44,
        description: [
            'Claudia Conserva y su belleza y naturalidad. La verdad es que no había mucho que hacer: ella es preciosa y muy fácil de fotografiar. Poco o nada mérito mío.'
        ],
        children: [
            {
                name: retrato_44
            },
        ]
    }, {
        name: 'Ian',
        image: retrato_45,
        description: [
            'Este retrato fue divertido. Estaba mostrándole unos equipos a unos estudiantes en la calle afuera de nuestro Laboratorio Fotográfico, cuando pasa mi amigo Ian. Le pedí que se pusiera cerca de la Luz y un solo disparo. Toda la gentileza de Ian en una foto única.'
        ],
        children: [
            {
                name: retrato_45
            },
        ]
    }, {
        name: 'Max',
        image: retrato_46,
        description: [
            'Retrato de mi Amigo y Abogado Max. '
        ],
        children: [
            {
                name: retrato_46
            },
        ]
    }, {
        name: 'Classic',
        image: retrato_48,
        description: [
            'Esta fue una campaña para una farmacia. Retratos súper clásicos de personas normales.  De verdad echo de menos el trabajo de laboratorio.  Fotografiar de día, revelar y ampliar de noche.'
        ],
        children: [
            {
                name: retrato_48
            },
            {
                name: retrato_49
            },
            {
                name: retrato_50
            },
            {
                name: retrato_51
            },
            {
                name: retrato_52
            },
        ]
    }, {
        name: 'Saturday Night Fever',
        image: retrato_53,
        description: [
            'Mi amigo Angel Torrez tuvo la audacia de montar Fiebre de Sábado por la noche, el musical, en el teatro Las Condes. Primera prueba de vestuario y todo el elenco en un subterráneo para hacer las fotos. Nada mejor que fotografiar artistas en sus papeles. Se meten tanto en el personaje que la actitud sale sola.'
        ],
        children: [
            {
                name: retrato_53
            },
            {
                name: retrato_54
            },
            {
                name: retrato_55
            },
            {
                name: retrato_56
            },
        ]
    }, {
        name: 'Pancho Zegers / DDB',
        image: retrato_57,
        description: [
            'Este debe ser el trabajo mas insólito que me pidieron nunca. Francisco Zegers, dueño de una Agencia de Publicidad me encomienda hacer una “Guerra de Tortas” para un libro anual de DDB en el mundo. Arriendo de un Palacio, Vestuario, Orquesta de Cámara, mozos, y por supuesto: Tortas. Tuvimos que iluminar todo el Salón con luz continua para poder hacer ráfagas de fotos con tres cámaras para asegurar una imagen. La guerra duró 16 segundos. Un cuarto del presupuesto se fue en limpieza y lavandería.'
        ],
        children: [
            {
                name: retrato_57
            },
        ]
    }, {
        name: 'FOL',
        image: retrato_1,
        description: [
            'Este trabajo para una financiera, no podía hacerse por temas prácticos en la calle asi que hicimos un montaje. Todo medido para guardar las proporciones a la foto del fondo, la cual hicimos de múltiples exposiciones para evitar la gente que circulaba.'
        ],
        children: [
            {
                name: retrato_1
            },
        ]
    }, {
        name: 'Eso',
        image: retrato_3,
        description: [
            'Trabajo para Esso antes que se fueran de Chile. En la sección de productos y alimentos hay mas de este trabajo con fotos de consumo. Pero aquí teníamos que hacer muchas imágenes en ruta, para lo cual pusimos los autos arriba de un “Camara car” con luces y recorrimos Chicureo sacando las fotos.'
        ],
        children: [
            {
                name: retrato_3
            },
        ]
    }, {
        name: 'Jaime',
        image: retrato_41,
        description: [
            'Mi gran amigo y colega Jaime Villaseca en un pequeño retrato antes de una sesión de fotos.'
        ],
        children: [
            {
                name: retrato_41
            },
        ]
    }, {
        name: 'Nicolás',
        image: retrato_47,
        description: [
            'Para Movistar el gran Nicolás Massú unos días antes de que partiera a jugar a Wimbledon.'
        ],
        children: [
            {
                name: retrato_47
            },
        ]
    }
]